import { FETCH_DEALER_SUCCESS, UPDATE_DEALER_SUCCESS } from 'constants/ActionTypes';
import { FETCH_BRANDS_BY_DEALER_SUCCESS } from 'modules/brands/actionsType';
import type { Brand } from 'modules/brands/types';
import { createReducer } from 'utils/ReduxUtils';

type BrandsByDealerIdState = Record<string, string[]>;

const initialState: BrandsByDealerIdState = {};

const fetchBrandsByDealerSuccessReducer = (state: BrandsByDealerIdState, { payload }: { payload: { dealerId: string; brands: Brand[] } }) => ({
  ...state,
  [payload.dealerId]: payload.brands.map(brand => brand.id),
} as BrandsByDealerIdState);

const updateWithDetailedDealer = (state: BrandsByDealerIdState, { payload }: { payload: { id: string; brandIds?: string[] } }) => {
  const brands = payload.brandIds ?? state[payload.id];
  if (brands) {
    return {
      ...state,
      [payload.id]: brands,
    } as BrandsByDealerIdState;
  }
  return state;
};

export default createReducer<BrandsByDealerIdState>(initialState, {
  [FETCH_BRANDS_BY_DEALER_SUCCESS]: fetchBrandsByDealerSuccessReducer,
  [FETCH_DEALER_SUCCESS]: updateWithDetailedDealer,
  [UPDATE_DEALER_SUCCESS]: updateWithDetailedDealer,
});
